module.exports = __webpack_public_path__ + "media/images/icons/filled/format-painter-eddf79262b76fcb6bec6ef8863ebd891.svg";